import { render, staticRenderFns } from "./ComponentConfirmarPendenciaBase.vue?vue&type=template&id=f46bfa8e&scoped=true"
import script from "./ComponentConfirmarPendenciaBase.vue?vue&type=script&lang=ts"
export * from "./ComponentConfirmarPendenciaBase.vue?vue&type=script&lang=ts"
import style0 from "./ComponentConfirmarPendenciaBase.vue?vue&type=style&index=0&id=f46bfa8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46bfa8e",
  null
  
)

export default component.exports